import { useNavigate } from 'react-router-dom';
import TopNavigation from '../../components/feature/TopNavigation';
import BottomNavigation from '../../components/feature/BottomNavigation';
import Card from '../../components/base/Card';
import Button from '../../components/base/Button';

interface MedicalService {
  id: string;
  title: string;
  description: string;
  price: string;
  duration: string;
  image: string;
  category: string;
  features: string[];
}

const medicalServices: MedicalService[] = [
  {
    id: '1',
    title: 'استشارة طبية عامة',
    description: 'فحص شامل مع طبيب مختص في الطب العام',
    price: '150 ريال',
    duration: '30 دقيقة',
    image: 'https://public.readdy.ai/ai/img_res/f937661697372fd1b3673a66da1da4cb.jpg',
    category: 'استشارات',
    features: ['فحص سريري شامل', 'تشخيص أولي', 'وصفة طبية', 'متابعة لمدة أسبوع']
  },
  {
    id: '2',
    title: 'تحاليل مختبرية شاملة',
    description: 'فحوصات دم ومختبرية متكاملة للكشف المبكر',
    price: '200 ريال',
    duration: '15 دقيقة',
    image: 'https://readdy.ai/api/search-image?query=Medical%20laboratory%20testing%20equipment%2C%20blood%20samples%2C%20modern%20lab%20setting%2C%20clean%20professional%20environment%2C%20medical%20technology%2C%20microscope%2C%20test%20tubes%2C%20bright%20lighting%2C%20healthcare%20photography&width=400&height=250&seq=service2&orientation=landscape',
    category: 'تحاليل',
    features: ['تحليل دم شامل', 'فحص السكر', 'فحص الكوليسترول', 'تقرير مفصل']
  },
  {
    id: '3',
    title: 'أشعة تشخيصية',
    description: 'أشعة سينية وتصوير طبي بأحدث الأجهزة',
    price: '300 ريال',
    duration: '20 دقيقة',
    image: 'https://readdy.ai/api/search-image?query=Medical%20X-ray%20imaging%20equipment%2C%20radiology%20department%2C%20modern%20medical%20technology%2C%20clean%20hospital%20environment%2C%20diagnostic%20imaging%2C%20professional%20healthcare%20setting%2C%20bright%20medical%20lighting&width=400&height=250&seq=service3&orientation=landscape',
    category: 'أشعة',
    features: ['أشعة سينية', 'تصوير بالموجات فوق الصوتية', 'قراءة فورية', 'تقرير مكتوب']
  },
  {
    id: '4',
    title: 'علاج طبيعي',
    description: 'جلسات علاج طبيعي متخصصة للتأهيل',
    price: '120 ريال',
    duration: '45 دقيقة',
    image: 'https://readdy.ai/api/search-image?query=Physical%20therapy%20session%2C%20physiotherapist%20helping%20patient%2C%20modern%20rehabilitation%20center%2C%20exercise%20equipment%2C%20professional%20healthcare%20environment%2C%20clean%20medical%20setting%2C%20therapeutic%20treatment&width=400&height=250&seq=service4&orientation=landscape',
    category: 'تأهيل',
    features: ['تقييم حالة المريض', 'برنامج علاجي مخصص', 'تمارين علاجية', 'متابعة التقدم']
  },
  {
    id: '5',
    title: 'خدمة الطوارئ',
    description: 'خدمة طوارئ على مدار الساعة',
    price: '500 ريال',
    duration: 'حسب الحالة',
    image: 'https://readdy.ai/api/search-image?query=Emergency%20medical%20services%2C%20ambulance%2C%20emergency%20room%2C%20medical%20emergency%20equipment%2C%20urgent%20care%2C%20hospital%20emergency%20department%2C%20professional%20medical%20staff%2C%20modern%20healthcare%20facility&width=400&height=250&seq=service5&orientation=landscape',
    category: 'طوارئ',
    features: ['استجابة فورية', 'فريق طبي متخصص', 'معدات متقدمة', 'نقل طبي آمن']
  },
  {
    id: '6',
    title: 'استشارة تخصصية',
    description: 'استشارة مع أطباء متخصصين في مختلف المجالات',
    price: '250 ريال',
    duration: '45 دقيقة',
    image: 'https://readdy.ai/api/search-image?query=Specialist%20medical%20consultation%2C%20expert%20doctor%20with%20patient%2C%20modern%20medical%20office%2C%20specialized%20healthcare%2C%20professional%20medical%20environment%2C%20advanced%20medical%20equipment%2C%20consultation%20room&width=400&height=250&seq=service6&orientation=landscape',
    category: 'تخصصات',
    features: ['طبيب متخصص', 'تشخيص دقيق', 'خطة علاجية', 'متابعة مستمرة']
  }
];

const categories = ['الكل', 'استشارات', 'تحاليل', 'أشعة', 'تأهيل', 'طوارئ', 'تخصصات'];

export default function Services() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50">
      <TopNavigation 
        title="الخدمات الطبية"
        showBack
        onBack={() => navigate('/')}
        rightAction={
          <button className="w-10 h-10 flex items-center justify-center rounded-full bg-gray-100 hover:bg-gray-200 transition-colors">
            <i className="ri-search-line text-lg text-[#333333]"></i>
          </button>
        }
      />
      
      <div className="pt-20 pb-24 px-4 space-y-6">
        {/* Categories Filter */}
        <div className="flex gap-2 overflow-x-auto pb-2">
          {categories.map((category, index) => (
            <button
              key={category}
              className={`px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-all ${
                index === 0
                  ? 'bg-[#007AFF] text-white'
                  : 'bg-white text-[#7A7A7A] border border-gray-200 hover:border-[#007AFF] hover:text-[#007AFF]'
              }`}
            >
              {category}
            </button>
          ))}
        </div>

        {/* Services Grid */}
        <div className="space-y-4">
          {medicalServices.map((service) => (
            <Card key={service.id} padding="md">
              <div className="space-y-4">
                <img
                  src={service.image}
                  alt={service.title}
                  className="w-full h-48 rounded-xl object-cover object-top"
                />
                
                <div className="space-y-3">
                  <div className="flex items-start justify-between">
                    <div className="flex-1">
                      <h3 className="font-bold text-[#333333] text-lg mb-1">{service.title}</h3>
                      <p className="text-[#7A7A7A] text-sm">{service.description}</p>
                    </div>
                    <span className="bg-[#34C759]/10 text-[#34C759] px-3 py-1 rounded-full text-xs font-medium">
                      {service.category}
                    </span>
                  </div>
                  
                  <div className="flex items-center gap-4 text-sm text-[#7A7A7A]">
                    <span className="flex items-center gap-2">
                      <i className="ri-money-dollar-circle-line text-[#007AFF]"></i>
                      {service.price}
                    </span>
                    <span className="flex items-center gap-2">
                      <i className="ri-time-line text-[#007AFF]"></i>
                      {service.duration}
                    </span>
                  </div>
                  
                  <div className="space-y-2">
                    <h4 className="font-medium text-[#333333] text-sm">ما يشمله:</h4>
                    <div className="grid grid-cols-2 gap-2">
                      {service.features.map((feature, index) => (
                        <div key={index} className="flex items-center gap-2 text-xs text-[#7A7A7A]">
                          <i className="ri-check-line text-[#34C759] text-sm"></i>
                          <span>{feature}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                  
                  <Button 
                    fullWidth 
                    size="md"
                    onClick={() => navigate('/booking')}
                  >
                    احجز الآن
                  </Button>
                </div>
              </div>
            </Card>
          ))}
        </div>
      </div>
      
      <BottomNavigation />
    </div>
  );
}
